export default __webpack_public_path__ + "static/media/smartSplit.73bacad9.png";